import { date, type DateLocale } from 'quasar';

export function isDateValid(dateStr: string, format: string, locale?: DateLocale): boolean {
    /**
     * Checks if the date is valid.
     *
     * This function uses the underlying Date.parse() method which is not strict, so it's a good start.
     * For more details, see: https://github.com/quasarframework/quasar/blob/ee1c311c2310216ffc4548e02314a02338309029/ui/src/utils/date/date.js#L463-L467
     */
    if (!date.isValid(dateStr)) {
        return false;
    }

    /**
     * The ISO 8601 standard allows for years less than 0, so we need to check for that.
     */
    const extractedDate = date.extractDate(dateStr, format, locale);
    if (extractedDate.getFullYear() < 0) {
        return false;
    }

    /**
     * Is the formatted date string the same as the original date string?
     *
     * This is to check if the date is valid but not in the correct format.
     * For example, '2020-01-01' is valid but not in the format of 'YYYY/MM/DD'.
     * Another example is '02/30/2024' which will validate as a date but it's not a valid date.
     */
    const formattedDate = date.formatDate(extractedDate, format, locale);
    if (formattedDate !== dateStr) {
        return false;
    }

    return true;
}
